import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useRemoveTraining } from "../../../../api/effects/mutations/Training/removeTraining";
import { RemoveModal } from "../../../../components/RemoveModal";
import { TrainingResponse } from "../../../../models/Training";
import { convertDate } from "../../../../utils/dateConvert";
import TrainingModal from "./TrainingModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

type Props = {
  data: TrainingResponse[];
};

export default function TrainingTable({ data }: Props) {
  const [editId, setEditId] = useState<number | null>(null);
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };

  const handleOpenEditModal = (id: number) => {
    setEditId(id);
  };

  const handleCloseEditModal = () => {
    setEditId(null);
  };

  const { mutateAsync: RemoveTraining } = useRemoveTraining({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveTraining(deletingId);
      handleCloseRemoveModal();
    }
  };

  return (
    <Grid container justifyContent="center">
      <TrainingModal
        open={!!editId}
        handleClose={handleCloseEditModal}
        ID={editId || undefined}
      />
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Training</TableCell>
                <TableCell>Penyelengara</TableCell>
                <TableCell>Kota</TableCell>
                <TableCell>Tahun Mulai</TableCell>
                <TableCell>Tahun Selesai</TableCell>
                <TableCell>Pembiyaan</TableCell>
                <TableCell align="center">Lulus</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <TableRow
                  key={row.TRAINING_ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() => handleOpenEditModal(row.TRAINING_ID)}
                      disabled={!!deletingId || !!editId}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell>{row.TRAINING}</TableCell>
                  <TableCell>{row.PENYELENGARA}</TableCell>
                  <TableCell>{row.KOTA}</TableCell>
                  <TableCell>{convertDate(row.TAHUN_MULAI)}</TableCell>
                  <TableCell>{convertDate(row.TAHUN_SELESAI)}</TableCell>
                  <TableCell>{row.PEMBIAYAAN}</TableCell>
                  <TableCell align="center">
                    {row.LULUS ? "Ya" : "Tidak"}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() =>
                        handleOpenRemoveModal(
                          `${row.TRAINING}`,
                          row.TRAINING_ID
                        )
                      }
                      disabled={!!deletingId || !!editId}
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SquareGrid>
    </Grid>
  );
}